var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { CreditOperation } from '@/interfaces/admin.interfaces';
import { formatDate, formatDateToBR } from '@/shared/utils/helpers';
import { date } from 'quasar';
import { addCreditsToAccount, removeCreditsFromAccount } from '@/clients/admin';
let AccountManagementCreditsForm = class AccountManagementCreditsForm extends Vue {
    constructor() {
        super(...arguments);
        this.creditSelected = 'export';
        this.amount = 0;
        this.loading = false;
        this.creditOptions = [
            { label: 'Cliques', value: 'click' },
            { label: 'Exportações', value: 'export' },
            { label: 'Cliques Ilimitados', value: 'unlimitedClick' },
        ];
        this.expiresDate = '';
        this.description = '';
        this.disableSubmit = true;
    }
    mounted() {
        // @ts-ignore
        this.$refs.inputAmount.$refs.qinput.$refs.input.focus();
        this.defaultExpiresDate();
        this.validateMinAmount('');
    }
    cannotSelect(item) {
        if (this.handleCannotSelectWhenRemoveOperation(item))
            return true;
        if (this.handleCannotSelectWhenAddOperation(item))
            return true;
        return false;
    }
    isCreditsValid() {
        return (this.operation === CreditOperation.ADD ||
            (this.creditSelected === 'unlimitedClick' &&
                this.account.credits.unlimited_click) ||
            (this.accountHasBalanceFor(this.creditSelected) && this.isAmountValid()));
    }
    accountHasBalanceFor(creditSelected) {
        return !!this.account.credits[creditSelected];
    }
    isAmountValid() {
        return (Number(this.amount) > 0 &&
            this.isAmountEqualsOrLowerThan(this.creditSelected));
    }
    isAmountEqualsOrLowerThan(creditSelected) {
        return Number(this.amount) <= this.account.credits[creditSelected];
    }
    handleCannotSelectWhenRemoveOperation(selectedItem) {
        if (this.operation === CreditOperation.REMOVE) {
            if (!this.account.credits.unlimited_click) {
                if (selectedItem.value === 'unlimitedClick')
                    return true;
                return false;
            }
            if (selectedItem.value === 'click')
                return true;
            return false;
        }
        return false;
    }
    handleCannotSelectWhenAddOperation(selectedItem) {
        if (this.operation === CreditOperation.ADD) {
            if (this.account.credits.unlimited_click) {
                if (selectedItem.value !== 'export')
                    return true;
            }
            return false;
        }
        return false;
    }
    handleShowTooltipHelper(scope) {
        if (this.operation === CreditOperation.ADD) {
            return ((this.account.credits.unlimited_click && scope.opt.value === 'click') ||
                scope.opt.value === 'unlimitedClick');
        }
        if (this.operation === CreditOperation.REMOVE) {
            return this.account.credits.unlimited_click && scope.opt.value === 'click';
        }
        return false;
    }
    validateMinAmount(val) {
        if (this.creditSelected === 'unlimitedClick' &&
            !this.account.credits.unlimited_click) {
            this.disableSubmit = false;
            return true;
        }
        if (+val >= 0 && this.amount !== null && Number(this.amount) > 0) {
            this.disableSubmit = false;
            return true;
        }
        this.disableSubmit = val !== null || val !== '' || true;
        return val === null || val === '' || 'O valor precisa ser maior que zero';
    }
    dateExpiresDisabledBeforeToday(date) {
        const today = new Date();
        return date < today;
    }
    onOperationChange(newOperation) {
        if (newOperation === CreditOperation.REMOVE) {
            this.creditSelected = 'export';
        }
        if (newOperation === CreditOperation.ADD &&
            this.account.credits.unlimited_click) {
            if (this.creditSelected === 'unlimitedClick')
                this.creditSelected = 'export';
        }
        // @ts-ignore
        this.$refs.inputAmount.$refs.qinput.validate();
    }
    onChangeCreditSelected(creditChoice) {
        // @ts-ignore
        //this.$refs.inputAmount.$refs.qinput.validate()
        if (creditChoice !== 'unlimitedClick') {
            // @ts-ignore
            this.$refs.inputAmount.$refs.qinput.$refs.input.focus();
        }
        else {
            this.disableSubmit = false;
        }
    }
    defaultExpiresDate() {
        const dateDefault = new Date();
        const day = dateDefault.getDate();
        dateDefault.setDate(day + 33);
        dateDefault.setHours(23, 59, 59, 999);
        this.expiresDate = formatDateToBR(date.formatDate(dateDefault.toString(), 'YYYY-MM-DD'));
    }
    confirmChanges() {
        this.creditsChange({
            type: this.creditSelected,
            amount: this.amount,
            expiresDate: this.expiresDate,
            description: this.description,
        });
        if (this.creditSelected === 'unlimitedClick') {
            this.initializeFields();
        }
        this.description = '';
    }
    async creditsChange(credits) {
        this.loading = true;
        credits.expiresDate = formatDate(credits.expiresDate);
        if (credits.type === 'unlimited_click')
            credits.type = 'unlimitedClick';
        const userId = this.$store.getters['admin/get_selected_user'];
        const accountId = this.$store.getters['admin/get_selected_account'];
        const payload = {
            [credits.type]: credits.type !== 'unlimitedClick' ? credits.amount : true,
            ...credits,
        };
        try {
            if (this.operation === 'add_credit') {
                await addCreditsToAccount(userId, payload);
            }
            if (this.operation === 'remove_credit') {
                await removeCreditsFromAccount(userId, payload);
            }
            await this.$store.dispatch('admin/fetch_account_info', { accountId });
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    initializeFields() {
        this.creditSelected = 'export';
        this.description = '';
    }
    get account() {
        return this.$store.getters['admin/get_selected_account_info'];
    }
};
__decorate([
    Prop({ default: CreditOperation.ADD })
], AccountManagementCreditsForm.prototype, "operation", void 0);
__decorate([
    Watch('operation')
], AccountManagementCreditsForm.prototype, "onOperationChange", null);
AccountManagementCreditsForm = __decorate([
    Component({
        components: {
            Input,
        },
    })
], AccountManagementCreditsForm);
export default AccountManagementCreditsForm;
